import {useLayoutEffect} from "react";
import {useSelector} from "react-redux";
import {useKeycloak} from "@react-keycloak/web";
import {PhoneHQButton, PhoneHQGlyph} from 'ch3-ui-lib';
import {selectIsSuperadmin, selectTenant} from "../../store/features/Auth/authSlice.ts";

export function SuperAdminBanner() {
    const {keycloak} = useKeycloak();
    const isSuperadmin = useSelector(selectIsSuperadmin);
    const tenant = useSelector(selectTenant);
    const operatorEmail = keycloak.tokenParsed?.email ?? keycloak.tokenParsed?.preferred_username;

    useLayoutEffect(() => {
        const el = document.getElementById('superadmin-banner');
        document.documentElement.style.setProperty(
            '--banner-height', el ? `${Math.ceil(el.offsetHeight)}px` : '0px');
        return () => document.documentElement.style.setProperty('--banner-height', '0px');
    }, [isSuperadmin, tenant]);

    if (!isSuperadmin) return null;

    return (
        <div id="superadmin-banner" className="z-[60] flex flex-wrap items-center justify-between gap-3 border-b border-warning-line bg-warning-tint px-6 py-2 text-sm text-warning-ink">
            <span>
                <strong>Platform support mode</strong> — you{operatorEmail && <> (<span className="font-mono">{operatorEmail}</span>)</>} are operating as superadmin on tenant{' '}
                <span className="font-mono">{tenant}</span> (reserved user id 9999). Actions are not attributed to a tenant user.
            </span>
            <PhoneHQButton variant="secondary" size="sm" onClick={() => keycloak.logout()}><PhoneHQGlyph name="exit_to_app" size={16}/>Sign out</PhoneHQButton>
        </div>
    );
}
